/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Seating_Min_PlayersInputs */



/**
* | output |
* | --- |
* | "At least 4 players required" |
*
* @param {Err_Seating_Min_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_seating_min_players = /** @type {((inputs?: Err_Seating_Min_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Seating_Min_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 4 joueurs sont requis")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requieren al menos 4 jugadores")
	if (locale === "pt") return /** @type {LocalizedString} */ ("São necessários pelo menos 4 jogadores")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sono necessari almeno 4 giocatori")
	return /** @type {LocalizedString} */ ("At least 4 players required")
});